import { render, staticRenderFns } from "./BotaoArquivo.vue?vue&type=template&id=61b8a5fa&scoped=true&lang=pug"
import script from "./BotaoArquivo.vue?vue&type=script&lang=js"
export * from "./BotaoArquivo.vue?vue&type=script&lang=js"
import style0 from "./BotaoArquivo.styl?vue&type=style&index=0&id=61b8a5fa&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b8a5fa",
  null
  
)

export default component.exports